import { RouteConfig } from 'vue-router'

const MatchList = () => import('../views/class-match-system/MatchList.vue')
const RecordScore = () => import('../views/class-match-system/record-score-basic/RecordScorePage.vue')
const RefereeModeEntry = () => import('../views/class-match-system/RefereeModeEntry.vue')
const Scan = () => import('../views/class-match-system/Scan.vue')

export const classMatchSystemRefereeModeRoute: RouteConfig = {
  path: '/class-match-system/referee-mode',
  name: 'class_match_system_referee_mode',
  component: RefereeModeEntry,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '裁判模式',
  },
}

export const classMatchSystemMatchListRoute: RouteConfig = {
  path: '/class-match-system/match-list',
  name: 'class_match_system_match_list',
  component: MatchList,
  meta: {
    title: '赛事列表',
  },
}

export const classMatchSystemScanRoute: RouteConfig = {
  path: '/class-match-system/scan',
  name: 'class_match_system_scan',
  component: Scan,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '关联设备',
  },
}

export const classMatchSystemRecordScoreRoute: RouteConfig = {
  path: '/class-match-system/record-score',
  name: 'class_match_system_record_score',
  component: RecordScore,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '裁判数据录入',
  },
}

export default [
  classMatchSystemRefereeModeRoute,
  classMatchSystemMatchListRoute,
  classMatchSystemRecordScoreRoute,
  classMatchSystemScanRoute,
]
